import { useEffect } from 'preact/hooks';

export function DocumentTitle({ children }) {
  useEffect(() => {
    document.title = typeof children === 'string' ? children : children.join('');
  }, [children]);
}
